export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6996.9c9cbb3c.jpg";